import { RouteComponentType } from '@src/lib/types';

const PublicRoute = ({ component: Component }: RouteComponentType) => {
  return <Component />;
};

export default PublicRoute;
